const assets = 'assets';

export default {
  sfxPath: `${assets}/sounds/sfx`,
  musicPath: `${assets}/sounds/music`,

  music: {
    bgm: { volume: 0.1, background: true, sources: ['BGM.mp3'] },
    match3: { volume: 0.1, background: true, sources: ['Match3_BGM.mp3'] },
  },

  sfx: {
    period: { volume: 1, background: false, sources: ['Period.mp3'] },
    speak: {
      volume: 0.5,
      background: false,
      sources: ['Speak-0.mp3', 'Speak-1.mp3', 'Speak-2.mp3'],
    },
    ok: { volume: 1, background: false, sources: ['OK.mp3'] },
    cancel: { volume: 1, background: false, sources: ['Cancel_Back.mp3'] },
    applause: { volume: 1, background: false, sources: ['Applause.mp3'] },
    tapPet: { volume: 1, background: false, sources: ['TapPet.mp3'] },
    progressAwarded: {
      volume: 1,
      background: false,
      sources: ['progress_awarded.mp3'],
    },
    progressCounted: {
      volume: 1,
      background: false,
      sources: ['progress_counted.mp3'],
    },
    timer: { volume: 1, background: false, sources: ['Timer.mp3'] },
    timerFast: { volume: 1, background: false, sources: ['TimerFast.mp3'] },
    timerEnd: { volume: 1, background: false, sources: ['End.mp3'] },
    match3Move: { volume: 1, background: false, sources: ['Move.mp3'] },
    match3Pop: { volume: 1, background: false, sources: ['Pop.mp3'] },
    match3Gems: { volume: 1, background: false, sources: ['Gems.mp3'] },
    ascension: { volume: 1, background: false, sources: ['Ascension.mp3'] },
  },
};
